import {
    Scene,
    DefaultRenderingPipeline,
    ColorGradingTexture,
    ColorCurves,
} from '@babylonjs/core';
import { stringUtil } from './stringUtil';

export class PostProcess {
    constructor(private scene: Scene) { }

    public run() {
        const defaultPipeline = new DefaultRenderingPipeline(
            "DefaultRenderingPipeline",
            true, // is HDR?
            this.scene,
            this.scene.cameras
        );
        if (defaultPipeline.isSupported) {
            /* imageProcessing */
            defaultPipeline.imageProcessingEnabled = true; //true by default
            if (defaultPipeline.imageProcessingEnabled) {
                defaultPipeline.imageProcessing.contrast = 1.1; // CONF
                defaultPipeline.imageProcessing.exposure = 4.07; // CONF
                /* color grading */
                defaultPipeline.imageProcessing.colorGradingEnabled = false; // false by default
                if (defaultPipeline.imageProcessing.colorGradingEnabled) {
                    // using .3dl (best) :
                    const url = stringUtil.createDownloadUrl('LateSunset.3dl');
                    defaultPipeline.imageProcessing.colorGradingTexture = new ColorGradingTexture(url, this.scene);
                    // using .png :
                }
                /* color curves */
                defaultPipeline.imageProcessing.colorCurvesEnabled = false; // false by default
                if (defaultPipeline.imageProcessing.colorCurvesEnabled) {
                    var curve = new ColorCurves();
                    curve.globalDensity = 0; // 0 by default
                    curve.globalExposure = 0; // 0 by default
                    curve.globalHue = 30; // 30 by default
                    curve.globalSaturation = 0; // 0 by default
                    curve.highlightsDensity = 0; // 0 by default
                    curve.highlightsExposure = 0; // 0 by default
                    curve.highlightsHue = 30; // 30 by default
                    curve.highlightsSaturation = 0; // 0 by default
                    curve.midtonesDensity = 0; // 0 by default
                    curve.midtonesExposure = 0; // 0 by default
                    curve.midtonesHue = 30; // 30 by default
                    curve.midtonesSaturation = 0; // 0 by default
                    curve.shadowsDensity = 0; // 0 by default
                    curve.shadowsExposure = 0; // 0 by default
                    curve.shadowsHue = 30; // 30 by default
                    curve.shadowsDensity = 80;
                    curve.shadowsSaturation = 0; // 0 by default;
                    defaultPipeline.imageProcessing.colorCurves = curve;
                }
            }

            /* chromatic abberation */
            defaultPipeline.chromaticAberrationEnabled = true; // false by default
            if (defaultPipeline.chromaticAberrationEnabled) {
                defaultPipeline.chromaticAberration.aberrationAmount = 2; // 30 by default
                defaultPipeline.chromaticAberration.adaptScaleToCurrentViewport = false; // false by default
                defaultPipeline.chromaticAberration.alphaMode = 0; // 0 by default
                defaultPipeline.chromaticAberration.alwaysForcePOT = false; // false by default
                defaultPipeline.chromaticAberration.enablePixelPerfectMode = false; // false by default
                defaultPipeline.chromaticAberration.forceFullscreenViewport = true; // true by default
            }
            /* glowLayer */
            defaultPipeline.glowLayerEnabled = false;
            if (defaultPipeline.glowLayerEnabled) {
                defaultPipeline.glowLayer!.blurKernelSize = 16; // 16 by default
                defaultPipeline.glowLayer!.intensity = 1; // 1 by default
            }
            /* grain */
            defaultPipeline.grainEnabled = true;
            if (defaultPipeline.grainEnabled) {
                defaultPipeline.grain.adaptScaleToCurrentViewport = false; // false by default
                defaultPipeline.grain.animated = false; // false by default
                defaultPipeline.grain.intensity = 3; // 30 by default
            }
            /* MSAA */
            if (this.scene.getEngine().webGLVersion > 1) {
                defaultPipeline.samples = 4; // 1 by default
            } else {
                defaultPipeline.samples = 1; // 1 by default
            }
            defaultPipeline.fxaaEnabled = true;
            /* sharpen */
            defaultPipeline.sharpenEnabled = true;
            if (defaultPipeline.sharpenEnabled) {
                defaultPipeline.sharpen.adaptScaleToCurrentViewport = false; // false by default
                defaultPipeline.sharpen.edgeAmount = 0.3; // 0.3 by default
                defaultPipeline.sharpen.colorAmount = 1; // 1 by default
            }
        }
    }
}
